import React, { useState } from "react";
import { Dropdown, Avatar, Badge, Button, Switch, message } from "antd";
import { UserOutlined, WalletFilled, BellOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import type { MenuProps } from "antd";
import { useAuthOrg } from "../../context/AuthOrgContext";
import { HelpCircle } from "lucide-react";


const ProfileMenu: React.FC = () => {
  const navigate = useNavigate();
  const { user, viewPiiAccess, viewPii, updateViewPii } = useAuthOrg();
  const [isUpdatingPii, setIsUpdatingPii] = useState(false);

  const profileDetails = user;

  const menuItems: MenuProps["items"] = [
    {
      key: "1",
      icon: <UserOutlined />,
      label: (
        <div onClick={() => navigate(`/settings/user-details`)}>Profile</div>
      ),
    },
    {
      key: "2",
      icon: <HelpCircle size={12} />,
      label: (
        <div onClick={() => navigate(`/help`)}>Help</div>
      ),
    },
  ];

  const notificationItems: MenuProps['items'] = [
    // {
    //   key: '1',
    //   label: 'New message from John',
    // },
    // {
    //   key: '2',
    //   label: 'Meeting reminder',
    // },
    // Add more notification items as needed
  ];

  const handlePiiToggle = async (enabled: boolean) => {
    setIsUpdatingPii(true);
    try {
      // The UI toggle represents masking, while the API flag represents PII visibility.
      await updateViewPii(!enabled);
      window.location.reload();
    } catch {
      message.error('Unable to update personal information visibility');
      setIsUpdatingPii(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      {viewPiiAccess && (
        <div className="flex items-center gap-2 text-xs text-gray-600 whitespace-nowrap">
          <span>Mask Personal Data</span>
          <Switch
            size="small"
            checked={!viewPii}
            loading={isUpdatingPii}
            onChange={handlePiiToggle}
          />
        </div>
      )}
      <WalletFilled className="text-2xl" /> <div className="pr-6 text-xl">₹0.00</div>
      <Dropdown menu={{ items: menuItems }} placement="bottomRight" arrow>
        <Avatar
          className="bg-blue-500 align-middle cursor-pointer" size="large" gap={4}
        >
          {(profileDetails?.userName?.[0]?.toLocaleUpperCase() || "") + (profileDetails?.userName?.[1]?.toLocaleUpperCase() || "")}
        </Avatar>
      </Dropdown>
      <Dropdown menu={{ items: notificationItems }} placement="bottomRight">
        <Badge count={0} offset={[-2, 4]}>
          <Button
            type="text"
            icon={<BellOutlined className="text-xl text-gray-600" />}
            className="flex items-center justify-center h-10 w-10 hover:bg-gray-100 rounded-full"
          />
        </Badge>
      </Dropdown>
    </div>
  );
};

export default ProfileMenu;
